// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.selfupload.LeaseDocumentUploadWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  DeleteDocumentRequestDto,
  GetUploadedFileDetailsResponseDto,
  GetUploadTokenResponseDto,
  RenameLeaseDocumentsRequestDto,
  ReorderDocumentsRequestDto,
  StoreDocumentRequestDto,
  StoreDocumentResponseDto,
} from '../..';

interface GetUploadedFileDetailsParams {
  leaseId: number;
}
interface GetZDocsUploadTokenParams {
  leaseId?: number;
  mergeWithMessageTokens?: boolean;
}
interface SubmitDocumentChangesParams {
  leaseId: number;
}

export const LeaseDocumentUploadWebApiHandler_deleteLeaseDocument_Path = '/api/web/v1/selfupload/deleteLeaseDocument';

/**
 * delete uploaded document for lease
 */
export const LeaseDocumentUploadWebApiHandler_deleteLeaseDocument = (
  postData: DeleteDocumentRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteDocumentRequestDto, void>(
    {
      endpoint: LeaseDocumentUploadWebApiHandler_deleteLeaseDocument_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_Path =
  '/api/web/v1/selfupload/getUploadedFileDetails';

/**
 * get uploaded lease document file details
 */
export const LeaseDocumentUploadWebApiHandler_getUploadedFileDetails = (
  getParams: GetUploadedFileDetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUploadedFileDetailsParams, never, GetUploadedFileDetailsResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_Path = '/api/web/v1/selfupload/getZDocsUploadToken';

/**
 * get zdocs access token for upload
 */
export const LeaseDocumentUploadWebApiHandler_getZDocsUploadToken = (
  getParams: GetZDocsUploadTokenParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetZDocsUploadTokenParams, never, GetUploadTokenResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDocumentUploadWebApiHandler_renameLeaseDocuments_Path = '/api/web/v1/selfupload/renameLeaseDocuments';

/**
 * rename lease document
 */
export const LeaseDocumentUploadWebApiHandler_renameLeaseDocuments = (
  postData: RenameLeaseDocumentsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RenameLeaseDocumentsRequestDto, void>(
    {
      endpoint: LeaseDocumentUploadWebApiHandler_renameLeaseDocuments_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments_Path =
  '/api/web/v1/selfupload/reorderLeaseDocuments';

/**
 * reorder lease documents
 */
export const LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments = (
  postData: ReorderDocumentsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ReorderDocumentsRequestDto, void>(
    {
      endpoint: LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseDocumentUploadWebApiHandler_storeDocumentId_Path = '/api/web/v1/selfupload/storeDocumentId';

/**
 * store zdocs document id
 */
export const LeaseDocumentUploadWebApiHandler_storeDocumentId = (
  postData: StoreDocumentRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, StoreDocumentRequestDto, StoreDocumentResponseDto>(
    {
      endpoint: LeaseDocumentUploadWebApiHandler_storeDocumentId_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseDocumentUploadWebApiHandler_submitDocumentChanges_Path =
  '/api/web/v1/selfupload/submitDocumentChanges';

/**
 * submit document fields changes
 */
export const LeaseDocumentUploadWebApiHandler_submitDocumentChanges = (
  getParams: SubmitDocumentChangesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SubmitDocumentChangesParams, never, void>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentUploadWebApiHandler_submitDocumentChanges_Path,
      method: 'POST',
      contextPath: '/leasing',
    },
    client,
  );
};
